import { configureStore } from "@reduxjs/toolkit";
import navReducer from "./navReducer";
import adminReducer from "../services/admin/adminReducer";
import { notificationReducer } from "./notificationReducer";
import { adminApi } from "../services/admin/admin.rtk.api";
import { organisationApi } from "../services/organisation/organisation.rtk.api";
import { gymApi } from "../services/gym/gym.rtk.api";
import { staffApi } from "../services/staff/staff.rtk.api";
import { subscriptionScreenApi } from "../services/subscription/subscriptionScreen.rtk.api";
import { subscriptionPaymentApi } from "../services/subscription/subscriptionPayment.rtk.api";
import { subscriptionBillingApi } from "../services/subscription/subscriptionBilling.rtk.api";
import { fileApi } from "../services/workout/files/file.rtk.api";
import { exerciseApi } from "../services/workout/exercise/exercise.rtk.api";
import { workoutSessionApi } from "../services/workout/workoutLibrary/session.rtk.api";
import { scheduleApi } from "../services/workout/schedule/schedule.rtk.api";
import { formatApi } from "../services/workout/workoutLibrary/format.rtk.api";
import { categoryApi } from "../services/workout/workoutLibrary/category.rtk.api";
import { equipmentApi } from "../services/workout/exercise/equipment.rtk.api";
import { muscleApi } from "../services/workout/exercise/muscle.rtk.api";
import { metricsApi } from "../services/workout/workoutLibrary/metrics.rtk.api";
import { groupApi } from "../services/workout/workoutLibrary/group.rtk.api";
import { deviceApi } from "../services/device/device.rtk.api";
import { subscriberApi } from "../services/subscriberManagement/subscriber.rtk.api";
import { segmentApi, tierApi } from "../services/subscriberManagement";
import { taxApi } from "../services/tax/tax.rtk.api";
import { planApi } from "../services/subscription/plan.rtk.api";

// 1. ADD THE IMPORT HERE (Make sure the path matches where you saved themeApi)
import { themeApi } from "../services/settings/setting.rtk.api"; 

import { rtkQueryToastMiddleware } from "./rtkQueryToastMiddleware";

export const store = configureStore({
  reducer: {
    navbar: navReducer,
    admin: adminReducer,
    notification: notificationReducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [organisationApi.reducerPath]: organisationApi.reducer,
    [gymApi.reducerPath]: gymApi.reducer,
    [staffApi.reducerPath]: staffApi.reducer,
    [subscriptionScreenApi.reducerPath]: subscriptionScreenApi.reducer,
    [subscriptionPaymentApi.reducerPath]: subscriptionPaymentApi.reducer,
    [subscriptionBillingApi.reducerPath]: subscriptionBillingApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [exerciseApi.reducerPath]: exerciseApi.reducer,
    [workoutSessionApi.reducerPath]: workoutSessionApi.reducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
    [metricsApi.reducerPath]: metricsApi.reducer,
    [formatApi.reducerPath]: formatApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [equipmentApi.reducerPath]: equipmentApi.reducer,
    [muscleApi.reducerPath]: muscleApi.reducer,
    [groupApi.reducerPath]: groupApi.reducer,
    [deviceApi.reducerPath]: deviceApi.reducer,
    [subscriberApi.reducerPath]: subscriberApi.reducer,
    [segmentApi.reducerPath]: segmentApi.reducer,
    [tierApi.reducerPath]: tierApi.reducer,
    [taxApi.reducerPath]: taxApi.reducer,
    [planApi.reducerPath]: planApi.reducer,
    
    // 2. ADD THE REDUCER HERE
    [themeApi.reducerPath]: themeApi.reducer, 
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      rtkQueryToastMiddleware,
      adminApi.middleware,
      organisationApi.middleware,
      gymApi.middleware,
      staffApi.middleware,
      subscriptionScreenApi.middleware,
      subscriptionPaymentApi.middleware,
      subscriptionBillingApi.middleware,
      fileApi.middleware,
      exerciseApi.middleware,
      workoutSessionApi.middleware,
      scheduleApi.middleware,
      formatApi.middleware,
      categoryApi.middleware,
      equipmentApi.middleware,
      muscleApi.middleware,
      metricsApi.middleware,
      groupApi.middleware,
      deviceApi.middleware,
      subscriberApi.middleware,
      segmentApi.middleware,
      tierApi.middleware,
      taxApi.middleware,
      planApi.middleware,
      
      // 3. ADD THE MIDDLEWARE HERE
      themeApi.middleware 
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;